export type AccountSanction = {
  id: string;
  action: string;
  reasonCode: string;
  createdAt: string;
  appeal: { id: string; status: string; createdAt: string; resolvedAt: string | null } | null;
};

export function unappealedActions(items: AccountSanction[]) {
  return items.filter((item) => item.appeal === null);
}
